<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="form" :inline="true" size="mini" ref="searchForm" label-width="85px">
          <el-form-item label="店铺简称">
            <el-select v-model="form.storeShortName" placeholder="请选择" clearable filterable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in storeList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工号">
            <el-input v-model.trim="form.workNo" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="form.userName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="客服类型">
            <el-select v-model="form.customerType" placeholder="请选择" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in ['售前', '售中', '售后', '其他']" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="平台客服ID">
            <el-input v-model.trim="form.platCustomerServiceId" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="客服等级">
            <el-select v-model="form.customerServiceLevel" filterable clearable placeholder="请选择" @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in customerServiceLevelList.filter((v) => v != '(空白)')" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任部门">
            <el-select v-model="form.responsibleDepartment" filterable clearable placeholder="请选择" @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in responsibleDepartmentList.filter((v) => v != '(空白)')" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位">
            <el-select v-model="form.workJobs" placeholder="请选择" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in workJobsList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="form.workStatus" placeholder="请选择" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in workStatusList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button type="warning" size="small" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="add">新增</el-button>
        <el-button type="danger" size="small" @click="delRow(false)">删除</el-button>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        :height="maxTableHeight"
        @selection-change="handleSelectionChange"
        row-key="dataId"
        v-loading="loading"
      >
        <el-table-column type="selection" width="45" :reserve-selection="true" fixed="left"></el-table-column>
        <el-table-column label="平台名称" prop="platformName" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column label="店铺名称" prop="storeFullName" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="店铺简称" prop="storeShortName" min-width="80" show-overflow-tooltip></el-table-column>
        <el-table-column label="平台客服ID" prop="platCustomerServiceId" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column label="全称客服ID" prop="serviceUserIdFull" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column label="姓名" prop="userName" width="70" show-overflow-tooltip></el-table-column>
        <el-table-column label="工号" prop="workNo" show-overflow-tooltip width="110"></el-table-column>
        <el-table-column label="岗位" prop="workJobs" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="客服类型" prop="customerType" show-overflow-tooltip width="80"></el-table-column>
        <el-table-column label="责任部门" prop="responsibleDepartment" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column label="公司名称" prop="companyName" show-overflow-tooltip></el-table-column>
        <el-table-column label="客服等级" prop="customerServiceLevel" show-overflow-tooltip></el-table-column>
        <el-table-column label="入职日期" prop="employTime" width="120"></el-table-column>
        <el-table-column label="状态" prop="workStatus" width="60"></el-table-column>
        <el-table-column label="更新人" prop="lastUpdatedBy" width="70"></el-table-column>
        <el-table-column label="更新时间" prop="lastUpdateDate" width="160"></el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scoped">
            <el-button type="text" @click="edit(scoped.row)">编辑</el-button>
            <el-button type="text" style="color: red" @click="delRow(scoped.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <add-edit
      ref="content"
      :visible.sync="dialogVisible"
      :customerServiceLevelList="customerServiceLevelList"
      :responsibleDepartmentList="responsibleDepartmentList"
      :rowData="rowData"
      :storeList="dialogStoreList"
      @success="onSearch"
      v-if="dialogVisible"
    ></add-edit>
  </content-panel>
</template>

<script>
import axios from '@/utils/axiosInstance';
import addEdit from './components/add&edit';
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';

export default {
  mixins: [tableMixin, pagePathMixin],
  components: { addEdit },
  data() {
    return {
      form: {
        storeName: '',
        workJobs: '',
        customerServiceLevel: '',
        storeShortName: '',
        workStatus: '',
        responsibleDepartment: '',
        customerType: '',
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      dialogConfig: {},
      rowData: {},
      storeList: [],
      multipleSelection: [],
      //客服等级
      customerServiceLevelList: [],
      //责任部门
      responsibleDepartmentList: [],
      //岗位
      workJobsList: [],
      //客服等级
      customerServiceLevelList: [],
      queryCriteria: [],
      searchFormData: [],
      dialogStoreList: [],
      workStatusList: [],
      loading: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  computed: {},
  mounted() {
    this.getCustomerServiceLevel();
    this.getUserStoreList();
    this.getWorkJobs();
    this.getWorkStatus();
    this.queryCriteriaList();
    this.$set(this.form, 'storeId', '');
    this.onSearch();
  },
  methods: {
    onSearch() {
      let userName = this.form.userName && this.form.userName.split(' ').length > 1000; //真实姓名
      if (userName) {
        this.$message.error('已超过1000条，请核对！');
        return;
      }
      let workNo = this.form.workNo ? this.form.workNo.toUpperCase() : ''; // 将工号转换为大写
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: 'storeShortName', //店铺
          val: [this.form.storeShortName && this.form.storeShortName != '全部' ? this.form.storeShortName : ''],
          op: 'in',
        },
        {
          attributeName: 'workNo', //工号
          val: [workNo],
          op: 'in',
        },
        {
          attributeName: 'userName', //真实姓名
          val: this.form.userName || '',
          op: 'like',
        },
        {
          attributeName: 'customerType', //客服类型
          val: [this.form.customerType && this.form.customerType != '全部' ? this.form.customerType : ''],
          op: 'in',
        },
        {
          attributeName: 'platCustomerServiceId', //平台客服ID
          val: this.form.platCustomerServiceId || '',
          op: 'like',
        },
        {
          attributeName: 'customerServiceLevel', //客服等级
          val: [this.form.customerServiceLevel ? this.form.customerServiceLevel : ''],
          op: 'in',
        },
        {
          attributeName: 'responsibleDepartment', //责任部门
          val: [this.form.responsibleDepartment && this.form.responsibleDepartment != '全部' ? this.form.responsibleDepartment : ''],
          op: 'in',
        },
        {
          attributeName: 'workJobs', //岗位
          val: [this.form.workJobs ? this.form.workJobs : ''],
          op: 'in',
        },
        {
          attributeName: 'workStatus', //状态
          val: [this.form.workStatus && this.form.workStatus != '全部' ? this.form.workStatus : ''],
          op: 'in',
        },
      ];
      this.init();
    },
    async init(type) {
      let userName = this.form.userName && this.form.userName.split(' ').length > 1000; //真实姓名
      if (userName) {
        this.$message.error('已超过1000条，请核对！');
        return;
      }
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      this.loading = true;
      let data = { ...this.currencyForm };
      data.pageSize = this.tableData.pageSize;
      data.pageNum = this.tableData.pageNum;
      data.reportCode = 'qualityCheckServiceConfig';
      data.queryMatch = filter || [];
      data.hasCount = 'Y';
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/qualityCheckServiceConfig`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
          this.getStoreName();
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.form = {
        storeName: '',
        workJobs: '',
        customerServiceLevel: '',
        storeShortName: '',
        workStatus: '',
        responsibleDepartment: '',
        customerType: '',
      };
      this.onSearch();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //店铺
    getStoreName() {
      let data = { ...this.currencyForm };
      data.groupAttr = 'storeShortName';
      data.reportCode = 'qualityCheckServiceConfig';
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.storeList = data;
      });
    },
    //岗位
    getWorkJobs() {
      let data = { ...this.currencyForm };
      data.groupAttr = 'workJobs';
      data.reportCode = 'qualityCheckServiceConfig';
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.workJobsList = data;
      });
    },
    //客服等级
    getCustomerServiceLevel() {
      let data = { ...this.currencyForm };
      data.groupAttr = 'customerServiceLevel';
      data.reportCode = 'qualityCheckServiceConfig';
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.customerServiceLevelList = data;
      });
    },
    //状态
    getWorkStatus() {
      let data = { ...this.currencyForm };
      data.groupAttr = 'workStatus';
      data.reportCode = 'qualityCheckServiceConfig';
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.workStatusList = data.filter((v) => v != '(空白)');
      });
    },
    // 新增 弹出dialog
    add() {
      this.rowData = null;
      this.dialogVisible = true;
    },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = row;
      this.dialogVisible = true;
    },
    async delRow(row) {
      if (!this.multipleSelection.length && !row) {
        this.$message.error('请选择后在进行操作');
        return;
      }
      let text = this.multipleSelection.length ? '确认删除选中的数据吗？' : '确认删除该条数据吗？'
      let status = await this.$confirm(text, '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let data = this.multipleSelection.length ? this.multipleSelection.map((v) => v.dataId) : [row.dataId];
      let res = await this.$q.qualityTestingManage.customerServiceDel({ data: data });
      if (res.success) {
        this.$message.success('删除成功');
      } else {
        this.$message.fail('删除失败');
      }
      this.onSearch();
    },
    queryCriteriaList() {
      this.$q.qualityTestingManage.queryCriteriaList().then((res) => {
        let { customerServiceLevelList, responsibleDepartmentList } = res.data || {};
        this.customerServiceLevelList = customerServiceLevelList;
        this.responsibleDepartmentList = responsibleDepartmentList;
      });
    },
    //弹窗店铺下拉
    getUserStoreList() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "storeInfoList";
      axios.post(`/ec-pc-api/custom/reports/data/storeInfoList`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.dialogStoreList = res.data.list;
        }
      });
    },
    //导入
    importExcel() {
      this.openSubPage({
        //核心语句
        path: '/customerServicePersonnelImport',
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: '客服人员配置导入.xlsx',
          appCode: 'ec-pc-new',
          reportName: 'qualityCheckServiceConfigImport',
        },
      });
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData,
        },
        reportName: 'customerStoreConfigExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
